import { z } from 'zod';
// ============================================================
// Common Schemas (공통 스키마)
// ============================================================
export const ApiSuccessResponseSchema = (dataSchema) => z.object({
    success: z.literal(true),
    data: dataSchema,
    message: z.string().optional(),
});
export const ApiErrorResponseSchema = z.object({
    success: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.string(), z.any()).optional(),
    }),
});
export const PaginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(20),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
export const PaginationMetaSchema = z.object({
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
    total: z.number().int().min(0),
    totalPages: z.number().int().min(0),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
});
export const IdParamSchema = z.object({
    id: z.string().cuid2(),
});
export const DateRangeQuerySchema = z.object({
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
});
export const SearchQuerySchema = z.object({
    q: z.string().min(1).max(100).optional(),
    filter: z.record(z.string(), z.string()).optional(),
});
// ============================================================
// File Upload Schemas
// ============================================================
export const FileUploadResponseSchema = z.object({
    url: z.string().url(),
    filename: z.string(),
    size: z.number().int().min(0),
    mimeType: z.string(),
    uploadedAt: z.date(),
});
// ============================================================
// Validation Helpers
// ============================================================
export const isCuid2 = (value) => {
    return z.string().cuid2().safeParse(value).success;
};
export const isValidUrl = (value) => {
    return z.string().url().safeParse(value).success;
};
export const isValidDateRange = (startDate, endDate) => {
    return startDate <= endDate;
};
export const createSuccessResponse = (data, message) => ({
    success: true,
    data,
    ...(message && { message }),
});
export const createErrorResponse = (code, message, details) => ({
    success: false,
    error: {
        code,
        message,
        ...(details && { details }),
    },
});
// ============================================================
// Error Codes
// ============================================================
export const ERROR_CODES = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_TOKEN: 'INVALID_TOKEN',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    INVALID_INPUT: 'INVALID_INPUT',
    NOT_FOUND: 'NOT_FOUND',
    ALREADY_EXISTS: 'ALREADY_EXISTS',
    INSUFFICIENT_CREDITS: 'INSUFFICIENT_CREDITS',
    PREMIUM_REQUIRED: 'PREMIUM_REQUIRED',
    INVITATION_EXPIRED: 'INVITATION_EXPIRED',
    INVALID_PASSWORD: 'INVALID_PASSWORD',
    AI_GENERATION_FAILED: 'AI_GENERATION_FAILED',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
    UPLOAD_FAILED: 'UPLOAD_FAILED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
    RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
};
//# sourceMappingURL=common.js.map